import { Button, Col, Flex, Row } from 'antd';
import { useRef, useState } from 'react';

import { trackButtonClick } from '../../../analytics/mixpanel';
import { SendRight } from '../../../assets';
import MagicIconSVG from '../../../assets/MagicIconSVG';
import WorkflowSelectDropdown from '../../../CommonComponents/specific/WorkflowSelectDropdown/WorkflowSelectDropdown';
import AppSelectPill from '../../../CommonComponents/UI/AppSelectPill/AppSelectPill';
import { useTakeTour } from '../../TakeTour/hooks/useTakeTour';

const ChatBoxWorkflowSelect = ({ loading, onSend }) => {
  const { dropdownAndMiscStates } = useTakeTour();
  const [firstSelectValue, setFirstSelectValue] = useState('mikeLegalMagic');
  const calculatedFirstSelectValue =
    dropdownAndMiscStates.workflowTabFirstSelectValue || firstSelectValue;
  const [presetId, setPresetId] = useState();
  const [workflowSelectOpen, setWorkflowSelectOpen] = useState(false);
  const selectRef = useRef(null);

  return (
    <WorkflowSelectDropdown
      ref={selectRef}
      open={workflowSelectOpen}
      value={presetId}
      onChange={setPresetId}
      type={calculatedFirstSelectValue}
      onOpenChange={(open) => {
        setWorkflowSelectOpen(open);
      }}
      onClear={() => {
        setPresetId(undefined);
        setWorkflowSelectOpen(false);
      }}
    >
      {({ SelectComponent }) => (
        <Row align='middle' wrap={false}>
          <Col flex='200px'>
            <AppSelectPill
              popupClassName='workflow-tab-first-select'
              open={dropdownAndMiscStates.appSelectPillOpen}
              options={[
                {
                  value: 'mikeLegalMagic',
                  label: (
                    <Flex align='center' gap={4}>
                      <span className='app-gradient-text'>MikeLegal&apos;s Magic</span>
                      <MagicIconSVG size={16} />
                    </Flex>
                  ),
                },
                {
                  value: 'workflow',
                  label: <span className='color-primary'>Your Workflow</span>,
                },
              ]}
              value={calculatedFirstSelectValue}
              onChange={(value) => {
                trackButtonClick({ type: `ChatBox Workflow Select - ${value}` });
                setFirstSelectValue(value);
                setPresetId(undefined);
                setWorkflowSelectOpen(true);
                selectRef.current?.focus();
              }}
            />
          </Col>
          <Col flex='auto'>{SelectComponent}</Col>
          <Col flex='none'>
            <Button
              loading={loading}
              icon={<SendRight />}
              disabled={!presetId}
              onClick={() => onSend(presetId)}
            />
          </Col>
        </Row>
      )}
    </WorkflowSelectDropdown>
  );
};

export default ChatBoxWorkflowSelect;
